export default __webpack_public_path__ + "static/media/spinner.d0db1660.gif";